// Google Analytics Configuration
export const GA_MEASUREMENT_ID = 'G-TT0R09FKWN'; // Your GA4 Measurement ID

// Define available metrics and dimensions
export const analyticsWidgets = {
  userMetrics: [
    { id: 'activeUsers', name: 'Active Users', type: 'line' },
    { id: 'newUsers', name: 'New Users', type: 'line' },
    { id: 'sessions', name: 'Sessions', type: 'line' },
    { id: 'bounceRate', name: 'Bounce Rate', type: 'line' }
  ],
  engagementMetrics: [
    { id: 'pageViews', name: 'Page Views', type: 'bar' },
    { id: 'avgSessionDuration', name: 'Avg. Session Duration', type: 'line' },
    { id: 'clickEvents', name: 'Click Events', type: 'bar' },
    { id: 'conversionRate', name: 'Conversion Rate', type: 'line' }
  ],
  businessMetrics: [
    { id: 'providerSignups', name: 'Provider Signups', type: 'bar' },
    { id: 'userSignups', name: 'User Signups', type: 'bar' },
    { id: 'categoryEngagement', name: 'Category Engagement', type: 'pie' },
    { id: 'revenue', name: 'Revenue', type: 'line' }
  ]
}; 